module.exports = __webpack_public_path__ + "img/7.677a54cd.jpg";